<script setup lang="ts">
import {useChatStore} from "../../../store/chat";
import {useModalStore} from "../../../store/modal";
import DefaultModalBase from "../DefaultModalBase.vue";
import {computed, ref} from "vue";

const store = useChatStore()
const modalStore = useModalStore()
const loading = ref(false)
const contact_blocked = ref(!!modalStore?.props?.contact?.blocked_chat_contact)
const refresh = ref(false)
const disabled = computed(() => loading.value || !reason.value && !contact_blocked.value)
const heading = computed(() =>
    refresh.value
        ? `${modalStore?.props?.contact?.profile_name} has been ${contact_blocked.value ? "unblocked" : "blocked"} successfully.`
        : !contact_blocked.value ? `Give a reason for blocking ${modalStore?.props?.contact?.profile_name}.` : `Are you sure you want to unblock this ${modalStore?.props?.contact?.profile_name}?`
)
const reason = ref()
const blockContact = async () => {
    loading.value = true
    await store.toggleContactBlock(modalStore?.props?.contact?.id, reason.value)
    loading.value = false
    refresh.value = true
}
</script>

<template>
    <DefaultModalBase :heading :icon="contact_blocked ? 'check-all' : 'cross-default'" :loading :refresh="refresh">
        <div class="call-assign-container">
            <brand-form-textarea label="Reason." v-model="reason" v-if="!contact_blocked && !refresh"/>
            <brand-button @click="blockContact()" :disabled v-if="!refresh">
                {{ !contact_blocked ? "Block contact" : "Unblock contact" }}
            </brand-button>
            <brand-button @click="modalStore.close(refresh)" variant="secondary" v-else>Done</brand-button>
        </div>
    </DefaultModalBase>
</template>

<style scoped lang="scss">
.call-assign-container {
    display: flex;
    flex-direction: column;
    gap: 3rem;
}
</style>
